export const strings = {
  app_name: 'Baazar',

  cache_landing: 'CACHE_LANDING',
  last_filter: 'LAST_FILTER',

  shared_preferences_introduce: 'SHARED_PREFERENCES_INTRODUCE',
  shared_preferences_google_play_dismiss: 'SHARED_PREFERENCES_GOOGLE_PLAY_DISMISSED',

  account_token: 'ACCOUNT_TOKEN',
  remaining_Time: 'remainingTime',

  invalid_phone_number: 'شماره وارد شده صحیح نیست',
  license_approval_not_checked: 'ابتدا قوانین و مقررات را تایید کنید.',
  problem_on_connecting_to_server: 'خطا در اتصال به سرور',
  retry: 'تلاش مجدد',
  support_number: '02165013024',

  complete_not_verify: 'در حال بررسی',
  verify: 'کامل',
  rejected: 'رد شده',
  unknown: 'ناقص',

  accept: "تایید",
  accepted: "تاییده شده",
  checking: "درحال بررسی",
  password_changed_successfully: "رمز عبور با موفقیت تغییر کرد",
  ok: "باشه",
  repassword_is_not_correct: "تکرار کلمه عبور اشتباه است",
  password_is_not_valid: "کلمه عبور معتبر نمی باشد",
  password_is_empty: "کلمه عبور را وارد نمایید",
  password_not_correct: "کلمه عبور صحیح نمی باشد",
  added_successfully: "با موفقیت افزوده شد",
  data_incomplete: "لطفا اطلاعات را کامل وارد نمایید",
  verification_code_resent: "کد فعالسازی مجدد ارسال شد",
  ticket_status_new: "جدید",
  ticket_status_closed: "بسته شده",
  ticket_status_user_reply: "پاسخ کاربر",
  ticket_status_operator_reply: "پاسخ اپراتور",
  ticket_status_in_progress: "در دست اقدام",
  buy_succeed: "سفارش پلاک طلای شما با موفقیت ثبت شد  لطفا جهت تحویل با پشتیبانی تماس حاصل نمایید 02165013024",
  buy_success: "خرید با موفقیت انجام شد",
  sell_succeed: "فروش شما با موفقیت انجام شد",
  upload_accept: "بروزرسانی انجام شد",
  SettlementStateDONE: "انجام شده",
  SettlementStateTODO: "در حال بررسی",
  SettlementStateINPROGRESS: "ارسال به بانک",
  SettlementStateFAIL: "خطای پرداخت",
  SettlementStateUNKNOWN: "خطای ناشناخته",
  SettlementStateINVALIDSHEBA: "شبا نامعتبر",
  SettlementStateSUSPICIOUS: "مشکوک/بررسی مجدد",
  please_fill_all_date_elements: "لطفا بازه تاریخ را وارد نمایید",
  start_date_is_less_than_end_date: "تاریخ پایان از تاریخ شروع بازه کوچکتر است",
  ReceiveGoldProcessing: "در حال پردازش",
  ReceiveGoldReady: "آماده شده",
  ReceiveGoldSent: "ارسال شده",
  ReceiveGoldDelivered: "تحویل شده",
  ReceiveGoldRefunded: "بازپرداخت شد",
  fieldAnswerIsEmpty: "فیلد پاسخ سوال را پر کنید",
  incorrectAnswer: "پاسخ صحیح نیست",
  register: "خوش آمدگویی",
  userRefer: "معرفی کاربر",
  userFirstBuyN1: "سقف اول خرید",
  userReferBuy: "خرید کاربر معرفی شده",
  Unknowns: "نامشخص",
  matching: "محقق شده",
  expired: "محقق نشده",
  VIP: "VIP"
}
